module.exports = __webpack_public_path__ + "media/intro.450d4305.mp4";